<template>
  <div>
    <b class="button primary">Afgekeurd</b>
    <h1>
      Je hebt de aanvraag afgekeurd,<br> de medewerker ontvangt hierover bericht.
    </h1>
  </div>
</template>

<script>
export default {
  name: 'RequestDenied',
}
</script>

<style lang="scss" scoped>
  div {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  h1 {
    margin: 3rem;
    font-size: 2.5rem;
    color: #141e8c;
    font-weight: 400;
  }
  .button {
    cursor: default;
  }
  .primary {
    background-color: #ed0e52;
  }
</style>
